import { RootState } from '../index';
export const getCelebration = (state: RootState) => {
  return state.celebration;
};
